import { render, staticRenderFns } from "./RelatorioVouchers.vue?vue&type=template&id=54f70a1a&"
import script from "./RelatorioVouchers.vue?vue&type=script&lang=js&"
export * from "./RelatorioVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports